<template>
  <div>
    <scn data-name="been">
      <section-header
        :title="$t('been.title')"
        :subtitle="$t('been.subtitle')"
        alignment="center"
      />
      <div class="scn__content container">
        <div class="cards-carousel navigation-carousel">
          <carousel :per-page-custom="[[0, 2], [768, 3], [1200, 4]]"
                    navigation-enabled
                    navigation-next-label=""
                    navigation-prev-label=""
          >
            <slide>
              <logo-card
                logo="globo"
                url="https://g1.globo.com/bom-dia-brasil/noticia/2016/10/paraguai-e-nova-china-para-industria-brasileira-entenda.html"
              />
            </slide>
            <slide>
              <logo-card
                logo="bloomberg"
                url="https://www.bloomberg.com/news/articles/2017-01-09/brazil-worries-the-china-of-south-america-is-eating-its-lunch"
              />
            </slide>
            <slide>
              <logo-card
                logo="estadao"
              />
            </slide>
            <slide>
              <logo-card
                logo="rn"
                url="https://www.youtube.com/watch?v=-HPCgaVCkFM"
              />
            </slide>
            <slide>
              <logo-card logo="lide"
                         url="https://www.lideglobal.com/wp-content/uploads/2017/10/Meeting2017_20171016.pdf"
              />
            </slide>
            <slide>
              <logo-card
                logo="voce-sa"
              />
            </slide>
            <slide>
              <logo-card
                logo="abc-color"
                url="https://www.abc.com.py/especiales/remiandu/paraguay-hae-china-de-sudamerica-1554577.html"
              />
            </slide>
            <slide>
              <logo-card
                logo="istoe"
                url="https://istoe.com.br/em-alguns-casos-migracao-para-paraguai-visa-a-sobrevivencia-da-empresa/"
              />
            </slide>
            <slide>
              <logo-card
                logo="futura"
                url="https://www.youtube.com/watch?v=vwllZYyYhwc"
              />
            </slide>
            <slide>
              <logo-card
                logo="exame"
                url="https://exame.abril.com.br/economia/brasil-teme-ser-desbancado-pela-china-da-america-do-sul/"
              />
            </slide>
            <slide>
              <logo-card
                logo="la-nacion"
                url="https://www.lanacion.com.py/2017/01/10/paraguay-quiere-la-china-america-del-sur-aseguran/"
              />
            </slide>
            <slide>
              <logo-card
                logo="o-povo"
                url="https://www.opovo.com.br/noticias/economia/ae/2017/01/em-alguns-casos-migracao-para-paraguai-visa-a-sobrevivencia-da-empres.html"
              />
            </slide>
            <slide>
              <logo-card
                logo="istoe-dinheiro"
                url="https://istoe.com.br/em-alguns-casos-migracao-para-paraguai-visa-a-sobrevivencia-da-empresa/"
              />
            </slide>
          </carousel>
        </div>
      </div>
    </scn>
    <scn data-name="see" color="black">
      <section-header :title="$t('see.title')" :subtitle="$t('see.subtitle')" class="lg:ml-20 xxl:ml-0 lg:mt-3 xxl:mt-0" />
      <div class="scn__content container">
        <div class="see-scn-img xxl:-mt-3" />
        <div class="column-text-ctn mt-4 lg:mt-8 xxl:mt-4">
          <p v-for="paragraph in $t('see.paragraphs')" class="mb-2">
            {{ paragraph }}
          </p>
        </div>
      </div>
    </scn>
    <scn data-name="think">
      <section-header :title="$t('think.title')" :subtitle="$t('think.subtitle')" />
      <div class="scn__content container">
        <div class="lg:flex justify-end xxl:items-center">
          <div class="think-scn-img" />
          <p v-for="paragraph in $t('think.paragraphs')" class="think-paragraph">
            {{ paragraph }}
          </p>
        </div>
        <div class="think-scn-accordions-ctn">
          <accordion v-for="(accordion, index) in $t('think.accordions')"
                     :key="generateUniqueId(index)"
                     class="my-2"
                     :class="{'lg:mx-2' : index === 1}"
                     :title="accordion.title"
                     :subtitle="accordion.subtitle"
                     :text="accordion.text"
                     @click="toggleAccordion"
          />
        </div>
      </div>
    </scn>
    <scn data-name="live" color="grey">
      <div class="flex flex-col lg:flex-row justify-center items-center">
        <section-header :title="$t('live.title')" :subtitle="$t('live.subtitle')" />
        <div class="circular-img live-scn-img mt-5 lg:ml-5 lg:mt-0" />
      </div>
      <div class="scn__content container">
        <div class="live-scn-accordions-ctn">
          <accordion v-for="(accordion, index) in $t('live.accordions')"
                     v-if="index < 3"
                     :key="generateUniqueId(index)"
                     class="my-2"
                     :class="{'md:mx-2' : index === 1}"
                     :title="accordion.title"
                     :subtitle="accordion.subtitle"
                     :text="accordion.text"
                     @click="toggleAccordion"
          />
        </div>
        <div class="live-scn-accordions-ctn md:mt-2">
          <accordion v-for="(accordion, index) in $t('live.accordions')"
                     v-if="index > 2"
                     :key="generateUniqueId(index)"
                     class="my-2"
                     :class="{'md:mx-2' : index === 4}"
                     :title="accordion.title"
                     :subtitle="accordion.subtitle"
                     :text="accordion.text"
                     @click="toggleAccordion"
          />
        </div>
      </div>
    </scn>
    <scn data-name="practice" color="black">
      <div class="img-bg img-bg--practice">
        <section-header :title="$t('practice.title')" :subtitle="$t('practice.subtitle')" />
      </div>
      <div class="scn__content container">
        <div class="two-col-content">
          <div class="two-col-content__col two-col-content__col--expandable">
            <p v-for="paragraph in $t('practice.paragraphs')">
              {{ paragraph }}
            </p>
            <div class="mt-4">
              <feature-item v-for="(accordion, index) in $t('practice.accordions')"
                            :key="generateUniqueId(index)"
                            :title="accordion.title"
                            :subtitle="accordion.subtitle"
                            class="hidden lg:inline-block mb-2"
                            data-scope="practice"
                            :data-name="accordion.name"
                            :is-selected="selectedFeatureItem.practice === accordion.name"
                            @click="toggleFeatureItem"
              />
              <div class="accordions-row">
                <accordion v-for="(accordion, index) in $t('practice.accordions')"
                           v-if="index < 2"
                           :key="generateUniqueId(index)"
                           class="my-2 md:my-0 md:mx-2"
                           :title="accordion.title"
                           :subtitle="accordion.subtitle"
                           :text="accordion.text"
                           @click="toggleAccordion"
                />
              </div>
              <div class="accordions-row md:mt-2">
                <accordion v-for="(accordion, index) in $t('practice.accordions')"
                           v-if="index > 1"
                           :key="generateUniqueId(index)"
                           class="my-2 md:my-0 md:mx-2"
                           :title="accordion.title"
                           :subtitle="accordion.subtitle"
                           :text="accordion.text"
                           @click="toggleAccordion"
                />
              </div>
            </div>
          </div>
          <div class="vertical-divider hidden lg:block" />
          <div class="two-col-content__col hidden lg:block">
            <div v-for="accordion in $t('practice.accordions')" v-if="selectedFeatureItem.practice === accordion.name">
              <p v-for="paragraph in accordion.text" class="mb-2">
                {{ paragraph }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </scn>
    <scn data-name="have" color="grey">
      <section-header :title="$t('have.title')" :subtitle="$t('have.subtitle')" class="lg:mr-16 xxl:mr-0 lg:mt-4 xxl:mt-0" />
      <div class="scn__content container">
        <div class="flex flex-col lg:flex-row xxl:items-center mt-5 lg:mt-10 xxl:mt-5">
          <p v-for="paragraph in $t('have.paragraphs')" class="xxl:mr-3 xxl:w-128">
            {{ paragraph }}
          </p>
          <div class="have-scn-img" />
        </div>
        <div class="two-col-content mt-4">
          <div class="two-col-content__col two-col-content__col--expandable">
            <div class="mt-4 lg:mt-0">
              <feature-item v-for="(accordion, index) in $t('have.accordions')"
                            :key="generateUniqueId(index)"
                            :title="accordion.title"
                            :subtitle="accordion.subtitle"
                            class="hidden lg:inline-block mb-2"
                            data-scope="have"
                            :data-name="accordion.name"
                            :is-selected="selectedFeatureItem.have === accordion.name"
                            @click="toggleFeatureItem"
              />
              <div class="accordions-row">
                <accordion v-for="(accordion, index) in $t('have.accordions')"
                           v-if="index < 2"
                           :key="generateUniqueId(index)"
                           class="my-2 md:my-0 md:mx-2"
                           :title="accordion.title"
                           :subtitle="accordion.subtitle"
                           :text="accordion.text"
                           @click="toggleAccordion"
                />
              </div>
              <div class="accordions-row md:mt-2">
                <accordion v-for="(accordion, index) in $t('have.accordions')"
                           v-if="index > 1"
                           :key="generateUniqueId(index)"
                           class="my-2 md:my-0 md:mx-2"
                           :title="accordion.title"
                           :subtitle="accordion.subtitle"
                           :text="accordion.text"
                           @click="toggleAccordion"
                />
                <!--required to render so the third accordion be aligned-->
                <!--todo: converter em accordion-volume-maker-->
                <accordion v-for="(accordion, index) in $t('have.accordions')"
                           v-if="index === 2"
                           :key="generateUniqueId(index)"
                           class="hidden md:inline-block invisible my-2 md:my-0 md:mx-2"
                           :title="accordion.title"
                           :subtitle="accordion.subtitle"
                           :text="accordion.text"
                           @click="toggleAccordion"
                />
              </div>
            </div>
          </div>
          <div class="vertical-divider vertical-divider--short hidden lg:block" />
          <div class="two-col-content__col hidden lg:block">
            <div v-for="accordion in $t('have.accordions')" v-if="selectedFeatureItem.have === accordion.name">
              <p v-for="paragraph in accordion.text" class="mb-2">
                {{ paragraph }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </scn>
    <scn data-name="ready">
      <section-header :highlighted-word-index="0" :title="$t('ready.title')" :subtitle="$t('ready.subtitle')" />
      <div class="scn__content container">
        <p v-for="paragraph in $t('have.paragraphs')" class="mb-2">
          {{ paragraph }}
        </p>
      </div>
    </scn>
    <scn data-name="solutions" color="grey">
      <div class="flex flex-col lg:flex-row justify-center items-center">
        <section-header :title="$t('solutions.title')" :subtitle="$t('solutions.subtitle')" />
        <div class="circular-img solutions-scn-img mt-5 lg:ml-5 lg:mt-0" />
      </div>
      <div class="scn__content container">
        <div class="two-col-content">
          <div class="two-col-content__col">
            <p v-for="paragraph in $t('solutions.paragraphs')" class="mb-2">
              {{ paragraph }}
            </p>
          </div>
          <div class="two-col-content__col ml-3 mt-3 md:mt-0">
            <accordion v-for="(accordion, index) in $t('solutions.accordions')"
                       :key="generateUniqueId(index)"
                       :icon="customIconArr[index]"
                       :title="accordion.title"
                       :text="accordion.text"
                       class="mb-2"
                       @click="toggleAccordion"
            />
          </div>
        </div>
      </div>
    </scn>
    <scn data-name="performance">
      <div class="img-bg img-bg--performance">
        <section-header :title="$t('performance.title')" :subtitle="$t('performance.subtitle')" />
      </div>
      <div class="scn__content container">
        <p v-for="paragraph in $t('performance.paragraphs')">
          {{ paragraph }}
        </p>
        <div class="two-col-content mt-3">
          <div class="two-col-content__col">
            <accordion v-for="(accordion, index) in $t('performance.accordions')"
                       v-if="index < 6"
                       :key="generateUniqueId(index)"
                       inner-subtitle
                       :title="accordion.title"
                       :subtitle="accordion.subtitle"
                       :text="accordion.text"
                       @click="toggleAccordion"
            />
          </div>
          <div class="two-col-content__col">
            <accordion v-for="(accordion, index) in $t('performance.accordions')"
                       v-if="index > 5"
                       :key="generateUniqueId(index)"
                       inner-subtitle
                       :title="accordion.title"
                       :subtitle="accordion.subtitle"
                       :text="accordion.text"
                       @click="toggleAccordion"
            />
          </div>
        </div>
      </div>
    </scn>
    <scn v-if="$i18n.locale === 'pt'" class="testimony-bg-img py-3">
      <div class="scn__content container mt-0">
        <div class="testimony-carousel navigation-carousel">
          <carousel :per-page-custom="[[0, 1]]"
                    navigation-enabled
                    navigation-next-label=""
                    navigation-prev-label=""
                    pagination-active-color="#d8306a"
                    loop
                    autoplay
                    autoplay-hover-pause
                    :autoplay-timeout="5000"
          >
            <slide v-for="testimony in testimonies" :key="testimony.name">
              <testimony-item
                :image="testimony.photo.url"
                :name="testimony.name"
                :text="testimony.text"
              />
            </slide>
          </carousel>
        </div>
      </div>
    </scn>
    <scn data-name="cases">
      <section-header :title="$t('cases.title')" :subtitle="$t('cases.subtitle')" class="lg:ml-8" />
      <div class="cases-scn-img hidden lg:block" />
      <div class="scn__content container">
        <p v-for="paragraph in $t('cases.paragraphs')" class="mb-2 lg:ml-20 lg:-mt-3">
          {{ paragraph }}
        </p>
        <div class="cases-carousel navigation-carousel mt-5">
          <carousel :per-page-custom="[[0, 2], [768, 3], [992, 4], [1200, 5]]"
                    navigation-enabled
                    navigation-next-label=""
                    navigation-prev-label=""
                    loop
                    autoplay
                    autoplay-hover-pause
                    :autoplay-timeout="3000"
          >
            <slide v-for="item in cases" :key="item.name">
              <img :src="item.logo.url" :alt="`${$t('alt.logo')} ${item.name}`" class="case-img">
            </slide>
          </carousel>
        </div>
      </div>
    </scn>
  </div>
</template>

<script>
import SectionHeader from '@/components/section-header'
import LogoCard from '@/components/logo-card'
import Accordion from '@/components/accordion'
import uniqueId from 'lodash.uniqueid'
import FeatureItem from '@/components/feature-item'
import TestimonyItem from '@/components/testimony-item'
import api from '@/services/api.ts'

export default {
  name: 'Home',
  components: { TestimonyItem, FeatureItem, Accordion, LogoCard, SectionHeader },
  data () {
    return {
      cases: [],
      testimonies: [],
      customIconArr: ['rocket', 'stopwatch', 'bulb', 'hammer', 'floater'],
      selectedFeatureItem: {
        practice: 'liability',
        have: 'technology'
      }
    }
  },
  methods: {
    toggleAccordion (clickedAccordion) {
      const clickedAccordionId = clickedAccordion.id
      this.$store.state.accordions.forEach(accordion => {
        if (accordion.id !== clickedAccordionId) accordion.$data.isOpened = false
      })
      clickedAccordion.isOpened = !clickedAccordion.isOpened
    },
    toggleFeatureItem (clickedItem) {
      const itemScope = clickedItem.$el.getAttribute('data-scope')
      this.selectedFeatureItem[itemScope] = clickedItem.$el.getAttribute('data-name')
      this.$store.dispatch('cleanAccordionsArr')
      this.$root.$emit('update-accordions-list')
    },
    generateUniqueId (index) {
      return uniqueId(index)
    }
  },
  async created () {
    const responses = await Promise.all(
      [
        api.get('cases?populate=*'),
        api.get('testimonies?populate=*')
      ]
    )
    this.cases = responses[0].data.data
    this.testimonies = responses[1].data.data
  },
  mounted () {
    this.$root.$emit('content-fully-mounted')
  },
  comments: true
}
</script>

<style scoped lang="sass">
/* purgecss start ignore */
@tailwind utilities

.column-text-ctn
  columns: 1
  @screen lg
    columns: 2
    p
      @apply inline-flex
      page-break-inside: avoid

.cards-ctn
  @apply flex flex-col items-center
  @screen lg
    @apply inline-flex flex-row items-start justify-center
  &__inner-row
    @apply flex flex-col
    & > *
      @apply m-2
    @screen md
      @apply flex-row
    @screen sm-l
      @apply flex-row
  &--last-line
    @apply flex justify-start
    & > *
      @screen lg
        @apply ml-4

.see-scn-img
  @apply h-48
  background-image: url('~@/assets/images/sections/pessoa-montando-blocos.jpg')
  background-size: cover
  background-repeat: no-repeat
  @screen lg
    @apply absolute pin-l h-48
    top: 40px
    width: 41vw
    &::after
      @apply no-content absolute pin-t bg-pink w-1 h-full
      right: -10px
  @screen xxl
    @apply static mx-auto
    &::after
      content: none

.have-scn-img
  @apply h-48 mb-3
  background-image: url('~@/assets/images/sections/smartphone-em-praia-direcionamento.jpg')
  background-size: cover
  background-repeat: no-repeat
  background-position-y: 82%
  order: -1
  @screen lg
    @apply absolute pin-r h-64 mb-0
    top: 40px
    width: 41vw
    order: initial
  @screen xxl
    @apply static mx-auto

.think-scn-img
  @apply h-48
  background-image: url('~@/assets/images/sections/pessoas-juntando-maos-cooperacao.jpg')
  background-size: cover
  background-repeat: no-repeat
  @screen lg
    @apply absolute pin-l
    top: 185px
    width: 41vw
  @screen xxl
    @apply static

.think-paragraph
  @apply mt-3
  @screen lg
    width: 55%
  @screen xxl
    @apply mt-0 ml-3

.think-scn-accordions-ctn
  @apply flex flex-col mt-3
  @screen md
    @apply flex-row flex-wrap
  @screen lg
    @apply flex-no-wrap mt-12
  @screen xxl
    @apply mt-4

.live-scn-accordions-ctn
  @apply flex flex-col
  @screen md
    @apply flex-row

.img-bg
  @apply text-white -mx-3 -mt-5 py-5
  background-size: cover
  &--practice
    background-image: url('~@/assets/images/sections/pessoas-cooperando.jpg')
    background-repeat: no-repeat
    background-position-y: 45%
  &--performance
    background-image: url('~@/assets/images/sections/peca-xadrez-movida-estrategia.jpg')
    background-position-y: 55%

.vertical-divider
  @apply bg-pink w-px h-256 mx-3
  &--short
    @apply h-128

.circular-img
  @apply relative rounded-full h-64 w-64
  background-size: cover
  @screen lg
    @apply h-72 w-72
  &::after
    @apply no-content absolute half-t half-l -translate-xy-50 border-8 border-pink rounded-full
    width: 110%
    height: 110%

.live-scn-img
  background-image: url('~@/assets/images/sections/pessoas-trabalhando-usando-tablet.jpg')

.solutions-scn-img
  background-image: url('~@/assets/images/sections/mao-impedindo-blocos-de-derrubarem-outros-blocos.jpg')

.accordions-row
  @apply flex flex-col
  @screen md
    @apply flex-row justify-center
  @screen lg
    @apply hidden

.testimony-bg-img
  background: url('~@/assets/images/sections/microfone-em-fundo-desfocado.jpg') no-repeat
  background-size: cover

.VueCarousel-pagination
  background: red !important
.cases-scn-img
  @apply absolute pin-t w-64 h-72 bg-red
  background: url('~@/assets/images/sections/dardo-no-centro-de-alvo.jpg') no-repeat
  background-size: cover
  @screen lg
    left: 5vw
  @screen xl
    left: 10vw
  @screen xxl
    left: 15vw
  @screen xxxl
    left: 17vw
  @screen xxxxl
    left: 24vw

.case-img
  @apply block w-32 mx-auto
/* purgecss end ignore */
</style>
